import { Component, HostListener, Input, OnInit } from '@angular/core';
import { SummaryPage } from '../models/summary-page';
import { Region } from '../models/region';
import { MatTabChangeEvent } from '@angular/material/tabs';
import {ActivatedRoute, Router} from '@angular/router';
import {HelperService} from '../services/helper.service';
import {FormControl, FormGroup} from '@angular/forms';

/**
 * @title Tab group with aligned labels
 */

@Component({
    selector: 'app-subtabs-component',
    templateUrl: 'subtabs.component.html',
    styleUrls: ['subtabs.component.css'],
  })

export class SubtabsComponent implements OnInit {

  constructor(private route: ActivatedRoute,
              private router: Router,
              private helperService: HelperService) { }

  @Input() subpages: Array<SummaryPage>;
  selectedRegion: Region;
  tabIndex = 0;
  regionControl: FormControl;
  regionForm: FormGroup;
  iframeHeight = window.innerHeight - 60 - 48 - 60;
  iFrameLoading = true;

  @HostListener('window:resize')
  onWindowResize(): void {
    this.iframeHeight = window.innerHeight - 60 - 48 - 60;
  }

  ngOnInit(): void {
    this.subpages = this.helperService.groupByProduct(this.subpages);
    this.regionControl = new FormControl(this.subpages[this.tabIndex].availableRegions[0]);
    this.regionForm = new FormGroup({
      region: this.regionControl
    });

    // look for url params
    this.route.queryParams
        .subscribe(params => {
          // parse tab parameter
          // tslint:disable-next-line:radix
          if (params.tabIndex && !(parseInt(params.tabIndex) > this.subpages.length - 1)) {
            this.tabIndex = params.tabIndex;
          } else {
            this.tabIndex = 0;
          }
          // parse region parameter
          if (params.region) {
            this.selectedRegion = this.subpages[this.tabIndex].availableRegions.find(reg => {
              return reg.name.toUpperCase() === params.region.toUpperCase();
            });
            // handle undefined response from 'find'
            if (!this.selectedRegion) {
              this.selectedRegion = this.subpages[this.tabIndex].availableRegions[0];
            }
          } else {
            this.selectedRegion = this.subpages[this.tabIndex].availableRegions[0];
          }
          this.regionControl = new FormControl(this.subpages[this.tabIndex].availableRegions[this.selectedRegion.index]);
          this.regionForm = new FormGroup({
            region: this.regionControl
          });
        });

  }

  selectRegion(): void {
    this.iFrameLoading = true;
    this.helperService.passDataToUrlParam(this.tabIndex, this.regionControl.value.name);
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    this.iFrameLoading = true;
    this.tabIndex = tabChangeEvent.index;
    this.helperService.passDataToUrlParam(this.tabIndex, this.regionControl.value.name);
  }

  iFrameLoaded(): void {
    this.iFrameLoading = false;
    // Setting these form values again to force the DOM to reflect desired value in the Mat Select
    this.regionControl = new FormControl(this.subpages[this.tabIndex].availableRegions[this.selectedRegion.index]);
    this.regionForm = new FormGroup({
      region: this.regionControl
    });
  }

}
